class SafeLoadScripts extends HTMLElement {
  static requestedScripts = new Set();

  connectedCallback() {
    if (this.hasAttribute('data-load-on-visibility') &&
        !window.Shopify?.designMode && 'IntersectionObserver' in window) {
      const section = this.closest('.shopify-section');
      if (section) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.visibilityObserver.disconnect();
            this.loadScripts();
          }
        }, {rootMargin: '1000px 0px'});
        this.visibilityObserver.observe(section);
        return;
      }
    }
    this.loadScripts();
  }

  disconnectedCallback() {
    this.visibilityObserver?.disconnect();
  }

  loadScripts() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;
      const scriptType = script.dataset.scriptType || script.type;
      const requestKey = `${scriptType}:${script.src}`;
      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if (!scriptLoaded && !SafeLoadScripts.requestedScripts.has(requestKey)) {
        // Claim the URL before loading; several sections can request it before
        // the first module finishes registering its custom element.
        SafeLoadScripts.requestedScripts.add(requestKey);
        const postLoadedScript = document.createElement('script');
        const {src, defer, async} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = scriptType;
        postLoadedScript.addEventListener('error', () => {
          SafeLoadScripts.requestedScripts.delete(requestKey);
        }, {once: true});
        this.parentElement.appendChild(postLoadedScript);
      }
    });
  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);
